import { createSelector } from 'reselect';
import hasAppropriatelyNaturedQualities from './hasAppropriatelyNaturedQualities';

const getCategories = ({ myself: { categories } }) => categories;
const getQualities = ({ myself: { qualities } }) => qualities;

const inputs = [getCategories, getQualities];

const output = (categories, qualities) => [...categories]
  .map((c, i) => ({ ...c, id: i })) // Add an 'id' field
  .filter(c => c.qualities.length) // Exclude empty categories
  .filter(hasStatusNaturedQualities({ qualities })) // Exclude categories with no Status
  .sort(sortByName); // Sort by category name

export default createSelector(inputs, output);

export function hasStatusNaturedQualities({ qualities }) {
  // Only return categories that contain Status-natured qualities
  return hasAppropriatelyNaturedQualities('Status')({ qualities });
}

export function sortByName(a, b) {
  const aName = a.name;
  const bName = b.name;
  return aName.localeCompare(bName);
}